// Copyright 2021-2022 zcloak authors & contributors
// SPDX-License-Identifier: Apache-2.0

import { Box, Container as MuiContainer, styled, Typography } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import React from 'react';

const Wrapper = styled(Box)({
  marginTop: 200,
  paddingBottom: 300
});

const Container = styled(MuiContainer)({});

function Cell({ children }: { children: React.ReactNode }) {
  return (
    <Grid lg={3} md={3} sm={4} xs={12}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: 78,
          padding: 2.5,
          background: '#000000',
          border: '1px solid #D9D9D9',
          borderRadius: 2,
          textAlign: 'center',
          fontSize: 25,
          fontWeight: 700,
          color: '#fff',
          '>img': {
            width: '100%',
            height: '100%',
            objectFit: 'contain',
            objectPosition: 'center'
          }
        }}
      >
        {children}
      </Box>
    </Grid>
  );
}

function Partner() {
  return (
    <Wrapper>
      <Typography marginBottom={6} textAlign="center" variant="h1">
        Our Partners
      </Typography>
      <Container>
        <Grid columns={{ xs: 12, lg: 15 }} container spacing={1.5}>
          <Cell>
            <img src="partners/logo_moledao.webp" />
          </Cell>
          <Cell>
            <img src="partners/logo_legaldao.webp" />
          </Cell>
          <Cell>
            <img src="partners/logo_tusima.webp" />
          </Cell>
          <Cell>
            <img src="partners/logo_mirror.webp" />
          </Cell>
          <Cell>
            <img src="partners/logo_macondo.webp" />
          </Cell>
          <Cell>
            <img src="partners/logo_buidler.webp" />
          </Cell>
          <Cell>
            <img src="partners/logo_flock.webp" />
          </Cell>
          <Cell>
            <img src="partners/logo_web3go.webp" />
          </Cell>
          <Cell>
            <img src="partners/logo_snap.webp" />
          </Cell>
          <Cell>More joining...</Cell>
        </Grid>
      </Container>
    </Wrapper>
  );
}

export default Partner;
